





















import { Component, Prop } from 'vue-property-decorator'
import { LoadList } from '@shared/mixins/loadList'
import { find, join, map, split, toArray, ceil } from 'lodash'
import { DropdownMenu, DropdownItem, Popover, Sticky } from 'vant'
import { queryStoreofActivityList, queryConsultantList } from '../../category.service'
import { allowRefreshOrShare, inserted, unbind } from '@utils/index'
import CounselorList from '../counselorList/counselorList.vue'

import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

@Component({
  components: {
    [Sticky.name]: Sticky,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    CounselorList,
    [Popover.name]: Popover,
  },
})
export default class CategoryDefaultList extends LoadList {
  selectStore = ''
  selectDistance = true
  selectSale = false
  storeList: any[] = []
  title = '全部门店'
  scrollY = 0
  isDropDownSelected = false

  showPopover = false

  @Prop({ default: null }) readonly position!: any
  @Prop(Array) readonly spuList!: any[]

  get selectedAll() {
    return this.selectStore === ''
  }
  get spuIds() {
    const list = this.spuList && this.spuList.length > 0 ? map(this.spuList, (item: any) => item.spuId) : []
    return join(list, ',')
  }

  async created() {
    const response: ResponseCode = await queryStoreofActivityList(this.spuIds)
    if (response && response.code == '1') {
      this.storeList = map(toArray(response.data), (item: any) => {
        return {
          value: item.storeCode,
          text: item.storeName,
        }
      })
      this.storeList.unshift({
        value: '',
        text: '全部门店',
      })
    }
  }

  onLoad() {
    this.getList()
  }

  /* 打开下拉框前吸顶 */
  openDrop() {
    this.isDropDownSelected = false
    const counselorVanList = document.querySelector('#counselor-list') as HTMLElement
    counselorVanList.style.minHeight = '100vh'
    this.toTabSticky(1)
    allowRefreshOrShare(false)
    inserted()
  }
  /* 关闭下拉框后恢复原样 */
  closeDrop() {
    unbind()
    if (!this.isDropDownSelected) {
      window.scrollTo(0, this.scrollY)
    }
    const counselorVanList = document.querySelector('#counselor-list') as HTMLElement
    counselorVanList.style.minHeight = 'auto'
    /* 解决下拉菜单收起的时候不是从顶部收起的问题 */
    const tabSticky: HTMLElement = this.$refs.tabSticky as HTMLElement
    if (this.scrollY <= tabSticky.offsetTop) {
      const vanDropdownItems = document.querySelector('.van-dropdown-menu__bar--opened+div .van-dropdown-item') as HTMLElement
      const styleTop = vanDropdownItems.style.top
      vanDropdownItems.style.top = '0'
      setTimeout(() => {
        vanDropdownItems.style.top = styleTop
      }, 200)
    }
  }

  changeStore() {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(0)
      })
    }
    this.isDropDownSelected = true
    const currentStore: any = find(this.storeList, (o: any) => this.selectStore === o.value)
    this.selectStore = currentStore && currentStore.value
    this.title = currentStore && (currentStore.value ? currentStore.title : '全部门店')
    this.setInitResult()
    this.getList(callback)
  }
  changeDistance() {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(-1)
      })
    }
    this.selectDistance = !this.selectDistance
    this.selectSale = false
    this.setInitResult()
    this.getList(callback)
  }
  changeSale() {
    const callback = () => {
      this.$nextTick(() => {
        this.toTabSticky(-1)
      })
    }
    this.selectSale = !this.selectSale
    this.selectDistance = false
    this.setInitResult()
    this.getList(callback)
  }
  /* 切换条件时避免连续加载多页 */
  /* condition=0,不管当前滚动条位置在哪，始终尝试跳到tab位置 */
  /* condition=1,仅当前滚动条位置在tab上方时，才尝试跳到tab位置 */
  /* condition=-1,仅当前滚动条位置在tab下方时，才尝试跳到tab位置 */
  toTabSticky(condition: number) {
    this.scrollY = window.scrollY
    const tabSticky: HTMLElement = this.$refs.tabSticky as HTMLElement
    if (condition === 0) {
      window.scrollTo(0, tabSticky.offsetTop + 1)
    } else if (condition > 0 && window.scrollY <= tabSticky.offsetTop) {
      window.scrollTo(0, tabSticky.offsetTop + 1)
    } else if (condition < 0 && window.scrollY > tabSticky.offsetTop) {
      window.scrollTo(0, tabSticky.offsetTop + 1)
    }
  }

  async getList(callback?: any) {
    this.result.loading = true
    const pageIndex = ++this.result.pageIndex
    const pageSize = this.result.pageSize
    const response: ResponseCode = await queryConsultantList({
      pageIndex,
      pageSize,
      spuId: split(this.spuIds, ','),
      storeCode: this.selectStore || undefined,
      longitude: this.position && this.position.lng,
      latitude: this.position && this.position.lat,
      sort: this.selectSale ? 1 : this.selectDistance ? 2 : undefined,
    })
    if (pageIndex === 1) {
      this.result.list = []
    }
    this.result.loading = false
    if (response && response.code == '1') {
      const list: any[] = toArray(response.data)
      this.result.list = this.result.list.concat(list)
      if (list.length < this.result.pageSize) {
        this.result.finished = true
      }
    } else {
      --this.result.pageIndex
      this.result.error = true
    }
    callback && callback()
  }
}
